import React from 'react';
import { MapPin, Award, Heart, Dumbbell, Salad } from 'lucide-react';

const FunFacts = () => {
  const funFacts = [
    { icon: <MapPin className="w-5 h-5" />, text: "Denver, CO native" },
    { icon: <Award className="w-5 h-5" />, text: "Ballet Trained 🩰" },
    { icon: <Heart className="w-5 h-5" />, text: "Psychology BA 📑" },
    { icon: <Dumbbell className="w-5 h-5" />, text: "Bikini Competitor 👙" },
    { icon: <Salad className="w-5 h-5" />, text: "NASM Certified + Nutrition Certification 🍋🧀🍌" }
  ];

  return (
    <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:scale-[1.02] relative group p-6 md:p-8 mt-6 w-full">
      <h3 className="text-lg font-semibold text-purple-900 mb-4">Fun Facts About Coach HT</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {funFacts.map((fact, index) => (
          <div key={index} className="flex items-center space-x-3">
            <div className="w-8 h-8 rounded-full bg-purple-50 flex items-center justify-center text-purple-600">
              {fact.icon}
            </div>
            <span className="text-gray-700">{fact.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FunFacts; 